<template>
    <div class="chartFormRoot">
      <div v-if="currentIndex==1" class="formBox">
        <div v-for="(item,index) in $t('tableModule.packageObj') " :key="index" class="packageItem" :style="{height:index==0?0:'', width:index==0?'0':'20%',overflow:index==0?'hidden':'auto'}">
            <div class="itemBlock" @click="changeSubIndex(index)" :style="{background:index==chooseIndexOfSubMonth?'#000':'',border:index==0?'none':''}">
                <div class="titleName" :style="{color:index==chooseIndexOfSubMonth?'#fff':''}">{{ item.title }}</div>
                
                <div class="chargeLine">
                  <div class="offerItem" v-if=item.offerAmount>
                    <div class="imgItem">
                        <div class="offerNum">{{ `${item.offerAmount} ` }}</div>
                        <img  class="chargSvG"  :src="imgObj.getOff" alt="">
                        
                    </div>
                  </div>
                    <span class="text1" :style="{color:index==chooseIndexOfSubMonth?'#fff':''}">$</span>
                    <span class="text2" :style="{color:index==chooseIndexOfSubMonth?'#fff':''}">{{ item.monthAmount }}</span>
                </div>
                <div class="unitItem">Monthly</div>
                 <div class="subscribeLine" :style="{color:btnStatus[index]?'':'#9E9E9E'}"   @click.stop="handleAddOrder('btnStatus2',index,item,'emptyLever')">{{$t('tableModule.buyBtn')}} </div>

            </div>
        </div>
      </div>
      <div v-else class="formBox">
        <div v-for="(item,index) in $t('tableModule.packageObj2') " :key="index" class="packageItem" :style="{height:index==0?0:'',width:index==0?'0':'20%',overflow:index==0?'hidden':'auto'}">
            <div class="itemBlock" @click="changeMonthIndex(index)" :style="{background:index==chooseIndexOfMonth?'#000':'',border:index==0?'none':''}">
                <div class="titleName" :style="{color:index==chooseIndexOfMonth?'#fff':''}">{{ item.title }}</div>
                
                <div class="chargeLine">
                    <div class="offerItem" v-if=item.offerAmount>
                        <div class="imgItem">
                            <div class="offerNum">{{ `${item.offerAmount} ` }}</div>
                            <img  class="chargSvG"  :src="imgObj.getOff" alt="">
                            
                        </div>
                    </div>
                    <span class="text1" :style="{color:index==chooseIndexOfMonth?'#fff':''}">$</span>
                    <span class="text2" :style="{color:index==chooseIndexOfMonth?'#fff':''}">{{ item.monthAmount }}</span>
                </div>
                <div class="unitItem">Monthly</div>
                <div class="subscribeLine" :style="{color:btnStatus2[index]?'':'#9E9E9E'}"  @click.stop="handleAddOrder('btnStatus2',index,item,'emptyLever')">{{$t('tableModule.buyBtn')}} </div>

            </div>
        </div>
       
      </div>
      
      <div class="chargTool">
        <div class="payLine">
            <div class="payItem" v-for="(item,index) in payList" :key="index">
                <img  class="payIcon"  :src="require(`../../assets/img/main/pay/${item.icon}`)" alt="">
                <span class="payText">{{ item.name }}</span>
            </div>
        </div>
        <div class="payLine">
            <div class="payItem" v-for="(item,index) in 5" :key="index">
                <img  class="toolIcon"  :src="require(`../../assets/img/newHome/tool${item}.png`)" alt="">
            </div>
        </div>
        <div class="textLine">
          <div class="textItem">* <span  class="textItem" >For more information please check our </span> <a :href="linkObj.refundPolicy" target="_blank"  class="textItem" style="color: #FEAE00;">Refund Policy</a> </div>
        </div>

      </div>
      <div class="serviceBox">
        <ServiceBlock :currentAmount="packageAmount"  :defaultNum="setDefault" :serviceLevel="[]"  :serviceNum="currentService" @sendMessage="handleMessageChange"></ServiceBlock>

      </div>
      <div class="lastSubLin">
        <div class="subBtn" @click.stop="handleSbuOrder">Subscribe Now</div>
        <div class="defBtn" @click="defaultSet">Default</div>
      </div>
    </div>
</template>
<script>
import { nextTick } from 'vue'
import {judgeLogin} from './loading'

 import ServiceBlock from './serviceBlock.vue'
  export default {
    components:{ServiceBlock},
    props:['currentStatus','toLink'],
    data() {
      return {
        imgObj:{
            mainLogo:require("../../assets/img/main/mainLogo.png"),
            chooseIcon:require("../../assets/img/main/chooseIcon.png"),
            getOff:require("../../assets/img/main/getOff.png"),
        },
         payList:[
            {name:'Card',icon:'card.png'},
            {name:'Apple Pay',icon:'applePay.png'},
            {name:'Google Pay',icon:'googlePay.png'},
            {name:'Alipay(one-time payments only)',icon:'alipay.png'},
            {name:'klarna(one-time payments only)',icon:'klarna.png'},
            {name:'Link',icon:'link.png'},
            {name:'Affirm',icon:'affirm.png'},
            {name:'Cash App Pay',icon:'cashAppPay.png'},
            {name:'Amazon Pay',icon:'amazonPay.png'},
        ],
        linkObj:{
            privacyNotice:"https://paperspotlight.com/paper-policy/privacyNotice.html",
            termsOfUse:"https://paperspotlight.com/paper-policy/termsOfUse.html",
            cookiePolicy:"https://paperspotlight.com/paper-policy/cookiePolicy.html",
            refundPolicy:"https://paperspotlight.com/paper-policy/refundPolicy.html",
            disclaimer:"https://paperspotlight.com/paper-policy/disclaimer.html",
        },
        currentService:[1],
        currentIndex:1,
        chooseIndexOfSubMonth:1,
        chooseIndexOfMonth:1,
        btnStatus:[true,true,true,true,true,true],
        btnStatus2:[true,true,true,true,true,true],
        receiveMessage: '',
        serverLever:[2,2,2,2],
        defauleWeight:[2,2,2,2],
        setDefault:2233,
        packageAmount:62.1 
      }
    },
    watch:{
      currentStatus(newVal, oldVal){
        console.log(newVal)
        this.currentIndex = newVal
        if(this.currentIndex == 1){
          this.currentService = []
            this.currentService[0] =  this.chooseIndexOfSubMonth
          this.packageAmount = this.$t('tableModule.packageObj')[this.chooseIndexOfSubMonth].monthAmount
            
        }else{
            this.currentService = []
            this.currentService[0] = this.chooseIndexOfMonth+10

          this.packageAmount = this.$t('tableModule.packageObj2')[this.chooseIndexOfMonth].monthAmount
        }
      }
    },
    methods: {
        handleMessageChange(message,leverArr){
            this.receiveMessage = message
            if(leverArr.length==4){
              let sum = 0;
              for (let i = 0; i < leverArr.length; i++) {
                  sum += leverArr[i];
              }
              if(sum==8){
                this.serverLever = [...leverArr]

              }else{
              this.serverLever = [...this.defauleWeight]

              }
            }else{
              this.serverLever = [...this.defauleWeight]
            }
           
            console.log('this.receiveMessage',this.receiveMessage,  this.serverLever)
        },
        changeSubIndex(index){
          console.log('changeSubIndex')
            this.chooseIndexOfSubMonth = index
            this.currentService = []
            this.currentService[0] = index
            this.receiveMessage= ''
            this.serverLever = [...this.defauleWeight]
            this.packageAmount = this.$t('tableModule.packageObj')[this.chooseIndexOfSubMonth].monthAmount
     
        },
        changeMonthIndex(index){
            this.chooseIndexOfMonth = index
            this.currentService = []
            this.currentService[0] = index+10
            this.receiveMessage= ''
            this.serverLever = this.defauleWeight
            this.packageAmount = this.$t('tableModule.packageObj2')[this.chooseIndexOfMonth].monthAmount
      
        },
        handleAddOrder(status,index,item,text){
          // console.log(index,item)
          // return
          const isLogin = judgeLogin()
          let userinfor = JSON.parse(localStorage.getItem('userInfo'))
          if(isLogin && userinfor&&item.link){
            console.log(  this.serverLever)
            let param = {}
            if(text){
              param = {
                4001: this.defauleWeight[0],
                4002:  this.defauleWeight[1],
                4003: this.defauleWeight[2],
                4004:  this.defauleWeight[3],

            }
            }else{
              param = {
                4001:  this.serverLever[0],
                4002:  this.serverLever[1],
                4003:  this.serverLever[2],
                4004:  this.serverLever[3],

              }
            }
            
            this.$https('savaPackageServerLevel',param).then(res => {
              console.log(res)
            }).catch(err=>{
            })

            let link = `${item.link}?client_reference_id=${userinfor.userId}`
            window.open(link, '_blank')
            setTimeout(() => {
              this.$emit('confirmPay')

            },500)
          }else{
            if(this.toLink){
              this.$emit('confirmPay')
              this.$router.push(this.toLink); 
            }else{
              this.$router.push('/login'); 
            }
          }
      
        },
        handleSbuOrder(){
            if(this.receiveMessage){
              this.$message.warning(this.receiveMessage);
              return
            }
            let index = 1
            let item = {}
            if(this.currentIndex == 1){
                console.log( this.$t('tableModule.packageObj') )
                index  = this.chooseIndexOfSubMonth
                item = this.$t('tableModule.packageObj')[this.chooseIndexOfSubMonth]
            }else{
                index = this.chooseIndexOfMonth
                item = this.$t('tableModule.packageObj2')[this.chooseIndexOfMonth]
            }
            this.handleAddOrder('btnStatus2',index,item)
        },
        //恢复到默认
        defaultSet(){
            this.setDefault = new Date().getTime();
            this.receiveMessage= ''
            this.serverLever = [...this.defauleWeight]
            console.log('eeeeeee,', this.setDefault)

        }
    },
    mounted: function() {
      let userData = JSON.parse(localStorage.getItem('userData'))
      console.log('userData',userData,this.currentStatus)
      if(userData&&userData.weight&&userData.weight.length){
        this.serverLever= [...userData.weight]
        this.defauleWeight= [...userData.weight]
      }
     
      this.currentIndex = this.currentStatus
      if(this.currentIndex == 1){
          this.packageAmount = this.$t('tableModule.packageObj')[this.chooseIndexOfSubMonth].monthAmount
      }else{
          this.packageAmount = this.$t('tableModule.packageObj2')[this.chooseIndexOfMonth].monthAmount
      }
      console.log('dffdfd',)
      this.changeMonthIndex(4)
      this.changeSubIndex(4)

    },
  }
</script>
<style  lang="scss" >
.chartFormRoot{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  .formBox{
    width: 100%;
    display: flex;
    margin-left:-30px;
    .packageItem{
      width: 20%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      padding:10px;
     
      .itemBlock{
        cursor: pointer;
        min-height: 200px;
        width: 100%;
        flex-shrink: 0;
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.20);
      
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding: 40px 0 ;
        .titleName{
            color: #000;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 110% */
        }
        .offerItem{
            position: absolute;
            right:0;
            top:-22px;
            width: 100%;
            padding-left: 30px;
            margin-bottom: -30px;
            text-align: center;
            .imgItem{
                position: relative;
                display: inline-flex;
                .offerNum{
                  width: 100%;
                  height: 100%;
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    padding-top: 5px;
                    color:#000;
                    text-align: center;
                    font-family: Arial;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    text-transform: capitalize;
                }
                .chargSvG{
                  width: 90px;
                  height: 28px;
                }
            }
        }
        .chargeLine{
          margin-top:22px;
          position: relative;
          width:100%;
          text-align:center;
            .text1{
                color: #000;
                font-size: 24px;
                font-style: normal;
                font-weight: 400;
                line-height: normal; /* 156.25% */
            }
            .text2{
                color:#000;
                font-size: 36px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
        }
        .unitItem{
            color: #999;
            /* 正文字体 */
            font-family: Arial;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
      }
      .itemBlock:hover{
        background: #FFF;
        border: none;
        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.10);
      }

      .titleItem{
        width: 100%;
        position: relative;
        background: #F5F5F5;
        display: flex;
        padding:  8px 0px;
        justify-content: center;
        align-items: center;
        gap: var(--4, 4px);
        color: #FEAE00;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        font-family: "PingFang SC";
        .titleBest{
          position: absolute;
          right: -45px;
          top: 45px;
          transform: rotate(90deg);
          .leftText{
            width: 120px;
            text-align: center;
            height: 30px;
            line-height: 30px;
            background: #FEAE00;
            color: #fafafa;
            font-size: 12px;
            font-family: "PingFang SC";
            font-weight: 600;
            padding: 0 10px ;
          }
          .triangle{
            position: absolute;
            right: -16px;
            top: 0;
            width: 0;
            height: 0;
            border:15px solid;
            border-color:#FEAE00 rgba(255, 0, 0, 0)  #FEAE00 #FEAE00;
          }
        }
      }

      .amountLine{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .text1{
            color: #212121;
            font-size: 18px;
            font-weight: 700;
            display: inline-block;
            margin-right: 3px;
            font-family: "PingFang SC";
          }
          .text2{
            color: #212121;
            font-size: 34px;
            font-weight: 700;
            font-family: "PingFang SC";
          }
          .text3{
            color: #9E9E9E;
            font-size: 18px;
            font-weight: 700;
            display: inline-block;
            margin: 0 3px;
            font-family: "PingFang SC";
          }
          .text4{
            display: inline-block;
            position: relative;
            color: #9E9E9E;
            font-size: 24px;
            font-weight: 700;
            font-family: "PingFang SC";

          }
          .monthItem{
            text-align: center;
            color: #9E9E9E;
            font-size: 16px;
            font-family: "PingFang SC";
          }
      }
      .perLine{
        padding-right: 10px ;
        box-sizing: border-box;
        .perItem{
          display: flex;
          align-items: center;
          .left{
            width: 47%;
            text-align: center;
            color:#212121;
            font-size: 22px;
            font-weight: 700;
            font-family: "PingFang SC";

            .leftText1{
              font-size: 16px;
              font-family: "PingFang SC";
            }
            .leftText2{
              font-family: "PingFang SC";
            }
          }
          .center{
            flex: 1 1;
            text-align: center;
          }
          .right{
            width: 47%;
            text-align: center;
            color:#FEAE00;
            font-size: 22px;
            font-weight: 700;
            font-family: "PingFang SC";
          }
        }
        .textItem{
          display: flex;
          justify-content: space-between;
          .text1{
            width: 49%;
            word-break: keep-all;
            color: var(--Grey-Grey-600, #757575);
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            font-family: "PingFang SC";
          }
        }
      }

      .cardLine{
        margin-top: 20px;
        border-radius: 4px;
        background: #F5F5F5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 12px 16px 22px ;
        .imgBlock{
          // margin-bottom: 16px;
          .imgItem{
            width: 80px;
            height: auto;
          }
        }
        
        .text1{
          color: #212121;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          word-break: keep-all;

        }
        .text2{
          word-break: keep-all;
          color: #212121;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: normal;
          line-height: normal;
        }
      }
      .subscribeLine{
        cursor: pointer;
        border-radius: 8px;
        background: #FEAE00;
        display: flex;
        // height: 40px;
        padding: 5px 16px;
        justify-content: center;
        align-items: center;
        gap: 10px;

        color:#212121;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; 
        font-family: "PingFang SC";
      }
      .subscribeLine:hover{
        background: #FFC23D;
      }
      .subscribeLine:active{
        background: #FEAE00;

      }
      .chooseBlock{
        display: flex;
        flex-direction: column;
        gap: 20px;
        .chooseItem{
          display: flex;
          gap: 6px;
          .chooseLeft{
            padding-top: 2px;
            .checkIcon{
              color: #FEAE00;
              font-size: 16px;
            }
            .closeicon{
              color: #9E9E9E;
              font-size: 16px;
            }
          }
          .chooseRight{
            flex: 1 1;
            font-family: "PingFang SC";
            font-size: 14px;
            word-break: keep-all;
          }
        }
      }
    }
  }
  .chargTool{
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .payLine{
      width: 100%;
      padding: 0  ; 
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      align-items: center;
      justify-content: center;
      // flex-wrap: wrap;
      .payItem{
          display: flex;
          align-items: center;
          gap: 4px;
          .payIcon{
              width: 20px;
              height: auto;
          }
          .payText{
              color: #212121;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              font-family: PingFang SC !important;
          }
          .toolIcon{
            width: auto;
             height: 46px;
          }
      }
  }
  .textLine{
      width: 100%;
      text-align: center;
      padding: 0 10vw;
      .textItem{
          color: #212121;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 25px; /* 178.571% */
          font-family: PingFang SC !important;
      }
  }
  .lastSubLin{
    display: flex;
    gap: 12px;
    .subBtn{
        font-family: PingFang SC;
        cursor: pointer;
        display: flex;
        box-sizing: border-box;
        padding: 5px 16px;
        // width: 80px;
        justify-content: center;
        align-items: center;
        border-radius: var(--8, 8px);
        background:  #FEAE00;
        color:  #212121;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .subBtn:hover{
        background: #f69f04;
    }
    .subBtn:active{
        background: #f69f04;
    }
    .defBtn{
      font-family: PingFang SC;
        cursor: pointer;
        display: flex;
        box-sizing: border-box;
        border: 1px solid #000;
        padding: 5px 16px;
        // width: 80px;
        justify-content: center;
        align-items: center;
        border-radius: var(--8, 8px);
        background:  #fff;
        color:  #000;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    // .defBtn:hover{
    //     background: #DCDCDC;
    // }
    // .defBtn:active{
    //     background: #EEE;
    // }
  }
  .wrapper{
      touch-action: pan-y !important;  //不能上下滑动的问题
  }
}
@media screen and (min-width: 767px) and (max-width: 1200px){
  .chartFormRoot{
    .formBox{
      .packageItem{
        width: 20%;
        gap: 3vw;
        .itemBlock{
          cursor: pointer;
          min-height: 200px;
          width: 100%;
          border-radius: 16px;
          border: 1px solid rgba(0, 0, 0, 0.20);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2vw;
          padding: 4vw 0 ;
          .titleName{
              color: #000;
              text-align: center;
              font-size: 1.2vw;
              font-style: normal;
              font-weight: 400;
              line-height: 2.2vw; /* 110% */
          }
          .offerItem{
              top:-2.2vw;
              width: 100%;
              padding-left: 2vw;
              margin-bottom: -3vw;
              text-align: center;
              .imgItem{
                  position: relative;
                  .offerNum{
                      position: absolute;
                      width: 100%;
                      text-align: center;
                      padding-top: 0.3vw;
                      color:#000;
                      text-align: center;
                      font-family: Arial;
                      font-size: 1.2vw;
                      font-style: normal;
                      font-weight: 700;
                      line-height: normal;
                      text-transform: capitalize;
                  }
                  .chargSvG{
                    width: 8.5vw !important;
                    height: 2.2vw !important;
                  }
              }
          }
          .chargeLine{
            margin-top:2.2vw;
              .text1{
                  color: #000;
                  font-size: 2vw;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal; /* 156.25% */
              }
              .text2{
                  color:#000;
                  font-size: 3.2vw;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
              }
          }
          .unitItem{
              color: #999;
              /* 正文字体 */
              font-family: Arial;
              font-size: 1.4vw;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
          }
        }
        .titleItem{
          padding:  1vw 0;
          gap:0.4vw;
          font-size: 1.6vw;
          .titleBest{
            right: -3.9vw;
            top: 3.2vw;
            transform: rotate(90deg);
            .leftText{
              width: 10.4vw;
              height: 2.4vw;
              line-height: 2.4vw;
              font-size: 1.2vw;
              padding: 0 1vw ;
            }
            .triangle{
              right: -1.3vw;
              top: 0;
              width: 0;
              height: 0;
              border:1.2vw solid;
              border-color:#FEAE00 rgba(255, 0, 0, 0)  #FEAE00 #FEAE00;

            }
          }
        }

        .amountLine{
            .text1{
              font-size: 1.2vw;
            }
            .text2{
              font-size: 2.6vw;
            }
            .text3{
              font-size: 1.2vw;
            }
            .text4{
              font-size: 1.6vw;
            }
            .monthItem{
              font-size: 1.2vw;
            }
        }
        .perLine{
          padding-right: 1vw ;
          .perItem{
            .left{
              width: 47%;
              font-size: 1.8vw;
              .leftText1{
                font-size: 1.4vw;
              }
            }
            .right{
              font-size: 1.8vw;
            }
          }
          .textItem{
            .text1{
              font-size: 1vw;
            }
          }
        }

        .cardLine{
          margin-top: 2vw;
          border-radius: 0.4vw;
          padding: 1.4vw 1.4vw 2vw ;
          .imgBlock{
            // margin-bottom: 1.6vw;
            .imgItem{
              width: 7vw;
            }
          }
          
          .text1{
            font-size: 1.1vw;
          }
          .text2{
            font-size: 1.1vw;
          }
        }
        .subscribeLine{
          border-radius: 0.8vw;
          // height: 4vw;
          padding: 0.5vw 1.6vw;
          gap: 1vw;

          font-size: 1.4vw;
          line-height: 2.2vw; 
        }
        .chooseBlock{
          gap: 2vw;
          .chooseItem{
            gap: 0.6vw;
            .chooseLeft{
              padding-top: 0.2vw;
              .checkIcon{
                font-size: 1.2vw;
              }
              .closeicon{
                font-size: 1.2vw;
              }
            }
            .chooseRight{
              font-size: 1.1vw;
              word-break: keep-all;
            }
          }
        }
      }
    }
    .chargTool{
      gap: 2vw;
    }
    .payLine{
        padding: 0 5vw ; 
        gap: 2vw;
        flex-wrap: wrap;
        justify-content: center;
        .payItem{
            gap: 1vw;
            .payIcon{
                width: 3vw;
            }
            .payText{
                font-size: 3vw;
            }
            .toolIcon{
              width: auto;
              height: 3.5vw;
          }
        }
    }
    .textLine{
        padding: 0  5vw;
        .textItem{
            font-size: 3vw;
            line-height: 2; 
        }
    }
    .lastSubLin{
      display: flex;
      gap: 1.2vw;
      .subBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          padding: 0.5vw 1.6vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          // background:  #000;
          // color:  #fff;
          text-align: center;
          font-size: 1.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 2vw;
      }
      .defBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          border: 1px solid #000;
          padding:0.5vw 1.6vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          background:  #fff;
          color:  #000;
          text-align: center;
          font-size: 1.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 2vw;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .chartFormRoot{
    .formBox{
    margin-left: -3vw;
      .packageItem{
        width: 20%;
        padding:1vw;
        gap: 3vw;
        .itemBlock{
          cursor: pointer;
          min-height: 10px;
          width: 100%;
          border-radius: 2vw;
          border: 1px solid rgba(0, 0, 0, 0.20);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2vw;
          padding: 4vw 0 ;
          .titleName{
              color: #000;
              text-align: center;
              font-size: 1.5vw;
              font-style: normal;
              font-weight: 400;
              line-height: 2.2vw; /* 110% */
          }
          .offerItem{
              top:-3.2vw;
              width: 100%;
              padding-left: 2vw;
              margin-bottom: -3vw;
              text-align: center;
              .imgItem{
                  position: relative;
                  .offerNum{
                      position: absolute;
                      width: 100%;
                      text-align: center;
                      padding-top: 0.15vw;
                      color:#000;
                      text-align: center;
                      font-family: Arial;
                      font-size: 1.3vw;
                      font-style: normal;
                      font-weight: 700;
                      line-height: normal;
                      text-transform: capitalize;
                  }
                  .chargSvG{
                    width: 9vw !important;
                    height: 2.2vw !important;
                  }
              }
          }
          .chargeLine{
            margin-top:3.2vw;
              .text1{
                  color: #000;
                  font-size: 2vw;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal; /* 156.25% */
              }
              .text2{
                  color:#000;
                  font-size: 3.2vw;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
              }
          }
          .unitItem{
              color: #999;
              /* 正文字体 */
              font-family: Arial;
              font-size: 1.4vw;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
          }
        }
        .titleItem{
          padding:  1vw 0;
          gap:0.4vw;
          font-size: 1.6vw;
          .titleBest{
            right: -3.9vw;
            top: 3.2vw;
            transform: rotate(90deg);
            .leftText{
              width: 10.4vw;
              height: 2.4vw;
              line-height: 2.4vw;
              font-size: 1.2vw;
              padding: 0 1vw ;
            }
            .triangle{
              right: -1.3vw;
              top: 0;
              width: 0;
              height: 0;
              border:1.2vw solid;
              border-color:#FEAE00 rgba(255, 0, 0, 0)  #FEAE00 #FEAE00;

            }
          }
        }

        .amountLine{
            .text1{
              font-size: 1.2vw;
            }
            .text2{
              font-size: 2.6vw;
            }
            .text3{
              font-size: 1.2vw;
            }
            .text4{
              font-size: 1.6vw;
            }
            .monthItem{
              font-size: 1.2vw;
            }
        }
        .perLine{
          padding-right: 1vw ;
          .perItem{
            .left{
              width: 47%;
              font-size: 1.8vw;
              .leftText1{
                font-size: 1.4vw;
              }
            }
            .right{
              font-size: 1.8vw;
            }
          }
          .textItem{
            .text1{
              font-size: 1vw;
            }
          }
        }

        .cardLine{
          margin-top: 2vw;
          border-radius: 0.4vw;
          padding: 1.4vw 1.4vw 2vw ;
          .imgBlock{
            // margin-bottom: 1.6vw;
            .imgItem{
              width: 7vw;
            }
          }
          
          .text1{
            font-size: 1.1vw;
          }
          .text2{
            font-size: 1.1vw;
          }
        }
        .subscribeLine{
          border-radius: 0.6vw;
          // height: 4vw;
          padding: 0.8vw 2.4vw;
          gap: 1vw;

          font-size: 1.2vw;
          line-height: 2; 
        }
        .chooseBlock{
          gap: 2vw;
          .chooseItem{
            gap: 0.6vw;
            .chooseLeft{
              padding-top: 0.2vw;
              .checkIcon{
                font-size: 1.2vw;
              }
              .closeicon{
                font-size: 1.2vw;
              }
            }
            .chooseRight{
              font-size: 1.1vw;
              word-break: keep-all;
            }
          }
        }
      }
    }
    .chargTool{
      gap: 4vw;
    }
      .payLine{
        padding: 0 4vw 0 10vw;
        gap: 1.2vw;
        .payItem{
            gap: 0.4vw;
            .payIcon{
                width: 2vw;
                height: auto;
            }
            .payText{
                font-size: 1.2vw;
            }
            .toolIcon{
              width: auto;
              height: 6vw;
            }
        }
    }
    .textLine{
        .textItem{
            font-size: 1.1vw;
            line-height: 1.6; /* 178.571% */
        }
    }
    .lastSubLin{
      display: flex;
      gap: 1.2vw;
      .subBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          padding: 1.4vw 2vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          // background:  #000;
          // color:  #fff;
          text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height:1.4;
      }
      .defBtn{
          cursor: pointer;
          display: flex;
          box-sizing: border-box;
          border: 1px solid #000;
          padding:1.4vw 2vw;
          // width: 80px;
          justify-content: center;
          align-items: center;
          border-radius: var(--8, 8px);
          background:  #fff;
          color:  #000;
          text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.4vw;
      }
    }
  }
}
</style>